import { useMemo } from 'react'
import PropTypes from 'prop-types'
import sanitizedContentData from '../../shared/utils/sanitizedContentData'
import { Link } from 'react-router-dom'
import './styles.sbcta.scss'

const BG_CLASS_MAP = {
  platinum: 'sectionBanner platinum',
  'eerie-black': 'sectionBanner eerieBlack',
  'force-blue': 'sectionBanner forceBlue',
}

const DEFAULT_BG = 'sectionBanner eerieBlack'

function LinkButton({ buttonLink }) {
  const urlCta = buttonLink?.url_cta

  if (!urlCta) return null

  if (!buttonLink.render_link) {
    return (
      <Link className="action-button" to={urlCta.url}>
        {urlCta.title}
      </Link>
    )
  }

  return (
    <a className="action-button" href={urlCta.url} target={urlCta.target}>
      {urlCta.title}
    </a>
  )
}

LinkButton.propTypes = {
  buttonLink: PropTypes.shape({
    render_link: PropTypes.bool,
    url_cta: PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
      target: PropTypes.string,
    }),
  }),
}

export default function SimpleBanerCta({ data }) {
  const colorBanner = data?.color_banner ?? 'eerie-black'
  const title = data?.title_section ?? 'Title'
  const description = data?.description ?? 'Description'
  const buttonLink = data?.button_link ?? null
  const contentBanner = data?.content_banner ?? null

  const bgClass = useMemo(() => BG_CLASS_MAP[colorBanner] ?? DEFAULT_BG, [colorBanner])

  return (
    <section className={bgClass}>
      <div className="main-container containerBanner">
        <div className="contentBanner">
          <div className="flex flex-col gap-[16px]">
            <h2 className="titleBanner">{title}</h2>
            <div
              className="description"
              dangerouslySetInnerHTML={sanitizedContentData(description)}
            />
          </div>
          <LinkButton buttonLink={buttonLink} />
          {contentBanner && (
            <div
              className="contentBannerExtra"
              dangerouslySetInnerHTML={sanitizedContentData(contentBanner)}
            />
          )}
        </div>
      </div>
    </section>
  )
}

SimpleBanerCta.propTypes = {
  data: PropTypes.shape({
    color_banner: PropTypes.oneOf(['platinum', 'eerie-black', 'force-blue']),
    title_section: PropTypes.string,
    description: PropTypes.string,
    button_link: PropTypes.object,
    content_banner: PropTypes.string,
  }),
}
